// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"6c9d577c","450":"15de83f6","453":"1bc3642b"}[chunkId] + ".chunk.js";
};